var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pt-0 text-center"},[_c('div',[_vm._v(" Bản quyền thuộc công ty CPĐT Vega Fintech ")]),_c('div',[_vm._v(" Địa chỉ: Tầng 3, tòa nhà Hòa Bình, 106 Hoàng Quốc Việt, Cầu Giấy, Hà Nội ")]),_c('div',[_vm._v(" MST: 0107815397 ")])])])
}]

export { render, staticRenderFns }